import type { JobType } from '@/enum'
import type {
  IDocument,
  IJobAssociatedTaskSheetUpdate,
  ITaskSheetBody,
  ITaskSheetSection
} from '@/interfaces'
import DocumentModel from '../DocumentModel'
import { TaskSheetSection } from '../task-sheets'
import TaskSheetBody from './TaskSheetBody'

class JobAssociatedTaskSheetUpdate implements IJobAssociatedTaskSheetUpdate {
  taskSheetId: string
  lastUpdatedAt?: string
  id?: string
  title: string
  description?: string
  type?: JobType
  header?: ITaskSheetSection
  bodies: ITaskSheetBody[]
  footer?: ITaskSheetSection
  documents?: IDocument[]

  constructor(associatedTaskSheetsUpdate?: any) {
    this.taskSheetId = associatedTaskSheetsUpdate?.taskSheetId
    this.lastUpdatedAt = associatedTaskSheetsUpdate?.updatedAt
    this.id = associatedTaskSheetsUpdate?.id
    this.title = associatedTaskSheetsUpdate?.title
    this.description = associatedTaskSheetsUpdate?.description
    this.type = associatedTaskSheetsUpdate?.type
    this.header = new TaskSheetSection(associatedTaskSheetsUpdate?.header)
    this.bodies =
      associatedTaskSheetsUpdate?.bodies?.map(
        (sheetUpdate: ITaskSheetBody) => new TaskSheetBody(sheetUpdate)
      ) ?? []
    this.footer = new TaskSheetSection(associatedTaskSheetsUpdate?.footer)

    this.documents = associatedTaskSheetsUpdate?.documents?.map(
      (document: any) => new DocumentModel(document)
    )
  }
}

export default JobAssociatedTaskSheetUpdate
